import React from "react";
import { ITempProfileData } from "../../../../../redux/profile/tempProfiles/slice";
import { IProfile } from "../../hooks/useProfileData";
import { ProfileCard } from "../ProfileCard";

interface OtherViewProps {
  allProfiles: IProfile[];
  tempProfilesData: { [profileId: string]: ITempProfileData };
  updateProfile: (profileId: string, field: keyof ITempProfileData, value: string) => void;
  validateProfile: (profileData: ITempProfileData, profileType: string) => boolean;
}

export const OtherView: React.FC<OtherViewProps> = ({
  allProfiles,
  tempProfilesData,
  updateProfile,
  validateProfile,
}) => {
  const groups: Array<{
    groupId: string | number;
    profiles: IProfile[];
    title: string;
    price?: number;
  }> = [];
  const map = new Map<string | number, typeof groups[0]>();

  allProfiles.forEach((profile) => {
    const key = profile.subscriptionId;
    if (!map.has(key)) {
      map.set(key, {
        groupId: key,
        profiles: [],
        title: profile.subscriptionTitle,
        price: profile.price,
      });
      groups.push(map.get(key)!);
    }
    const groupRef = map.get(key)!;
    groupRef.profiles.push(profile);
    if (groupRef.title == null) groupRef.title = profile.subscriptionTitle;
    if (groupRef.price == null) groupRef.price = profile.price;
  });

  return (
    <div>
      {groups.map((group) => (
        <div key={group.groupId}>
          {group.profiles.map((profile, index) => (
            <ProfileCard
              key={profile.id}
              profile={profile}
              index={index}
              subscriptionTitle={group.title}
              price={index === 0 ? group.price : undefined}
              tempProfilesData={tempProfilesData}
              updateProfile={updateProfile}
              validateProfile={validateProfile}
              showPrice={index === 0}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

